import React from "react";
import DraggableShape from "./DraggableShape.jsx";
import { useShapeDefinitions } from "../hooks";

/**
 * A toolbar containing all available draggable shapes
 * @returns {JSX.Element}
 */
const ShapeToolbar = () => {
  const shapeDefinitions = useShapeDefinitions();

  return (
    <div className="rad-shapes-toolbar">
      {shapeDefinitions.map((shape) => (
        <DraggableShape key={shape.id} shape={shape} />
      ))}
    </div>
  );
};

export default React.memo(ShapeToolbar);
